export default __webpack_public_path__ + "static/media/start.7220da56.png";